export default "__VITE_ASSET__e413d115__"